"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _sagas = _interopRequireDefault(require("./sagas"));

var _reducers = _interopRequireDefault(require("./reducers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//{ i18n, language, __instanceId }
var agentToken = function agentToken() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var exported = (0, _reactRedux.connect)(null)(agentToken);
var _default = exported;
exports.default = _default;
exported.reducer = _reducers.default;
exported.sagas = _sagas.default;

var logger = function logger(store) {
  return function (next) {
    return function (action) {
      console.log('dispatching', action);
      var result = next(action);
      console.log('next state', store.getState());
      return result;
    };
  };
};

exported.middlewares = [logger];